import { render } from "./message.bugreport.vue?vue&type=template&id=33ea36fe"
import script from "./message.bugreport.vue?vue&type=script&lang=js"
export * from "./message.bugreport.vue?vue&type=script&lang=js"

import "./message.bugreport.vue?vue&type=style&index=0&id=33ea36fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__